import React from 'react';
import cx from 'classnames';
import style from './card.module.scss';

const Card = ({ children, title, className, customContentClass }) => {

	return (
		<div className={cx(style.container, className)}>
			{title && <div className={style.title}>{title}</div>}
			<div className={cx(style.content, customContentClass)}>
				{children}
			</div>
		</div>
	);
};

export default Card;
